import { Link } from '@tanstack/react-router'
import type * as React from 'react'
import type { FooterItem } from './useFooterItems'

/** Settings tabs route inside the app; Monitoring and Billing open another site. */
export function FooterItemLink({ item, ...props }: { item: FooterItem } & React.ComponentProps<'a'>) {
	if ('href' in item.target) {
		return <a href={item.target.href} target='_blank' rel='noopener noreferrer' {...props} />
	}
	return <Link to={item.target.to} params={item.target.params} {...props} />
}
